/**
 * Get all configured recital types from the forum attributes.
 */
export function getRecitalTypes() {
  return app.forum.attribute('recitalsRecitalTypes') || [];
}

/**
 * Find the recital type that matches a discussion's tags.
 * Returns the matching type config or null.
 */
export function getRecitalTypeForDiscussion(discussion) {
  var types = getRecitalTypes();
  if (!types.length) return null;
  var tags = discussion.tags();
  if (!tags) return null;
  for (var i = 0; i < types.length; i++) {
    var type = types[i];
    var tagId = String(type.submission_tag_id);
    var hasTag = tags.some(function (t) {
      return t && String(t.id()) === tagId;
    });
    if (hasTag) return type;
  }
  return null;
}

/**
 * Check if a discussion has any configured submission tag.
 */
export function isSubmissionThread(discussion) {
  return getRecitalTypeForDiscussion(discussion) !== null;
}

/**
 * Get all configured submission tag IDs.
 */
export function getSubmissionTagIds() {
  return getRecitalTypes().map(function (t) {
    return String(t.submission_tag_id);
  });
}